module.exports = __webpack_public_path__ + "static/fonts/Arial.07d53b5b.ttf";